module.exports = __webpack_public_path__ + "static/media/profile-vanessa-bobb.4f78c813.jpg";